import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('payment');

export class Configurations extends Api {
  constructor(http, config = {}) {
    super(http, url, 'configurations', config);
  }
}